var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * @description 将一个支持callback的函数转换成支持promise的
 * @param {Function} fn - 支持callback的函数
 * @param {Object} context - 执行环境
 * @returns {Function}
 */
export function promisefy(fn, context) {
    return function (...args) {
        return new Promise((resolve, reject) => {
            const cb = (err, payload) => {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(payload);
                }
            };
            fn.apply(context, [...args, cb]);
        });
    };
}
/**
 * @description 获取链接参数的值
 * @param {String} url - 链接地址
 * @param {String} name - 参数名称
 * @returns {String} - 参数值
 */
export function getQueryString(url, name) {
    if (!url || !name)
        return;
    return url.match(new RegExp(`(^${name}|[?|&]${name})=([^&#]+)`))
        ? RegExp.$2
        : '';
}
/**
 * @description 数字格式化容量大小
 * @param {Number} bytes 字节数
 * @param {Number} point 小数点保留的位置
 */
export function bytesToSize(bytes, point = 1) {
    if (Number(bytes) <= 0) {
        return '0 B';
    }
    const k = 1024; // or 1024
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const val = bytes / Math.pow(k, i);
    let size = val.toPrecision(3);
    size = val.toFixed(point);
    return size + sizes[i];
}
/**
 * @description 数字格式化容量大小
 * @param {any} size 字节数
 */
export function formatSize(size) {
    size = parseInt(size);
    if (!size) {
        return 0;
    }
    const sizeMap = ['B', 'KB', 'M', 'G', 'T'];
    let index = 0;
    while (size > 1024) {
        size = size / 1024;
        index++;
    }
    size = String(size.toFixed(1));
    if (/(.0)/.test(size))
        size = size.split('.0')[0];
    return `${size}${sizeMap[index]}`;
}
/**
 * @description promise方式的等待定时器
 * @param {number} millisecond 持续时间 ms
 * @returns {Promise<void>} 返回promise
 */
export function sleep(millisecond) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(null);
        }, millisecond);
    });
}
/**
 * @description 判断是否为有效的可下载链接
 * @param {string} url
 */
export function checkValidLink(url) {
    return /^(thunder|magnet|http[s]?|ftp|ed2k):/i.test(url);
}
/**
 * @description 判断是否为json字符串
 * @param {string} str
 */
export function checkIsJSON(str) {
    if (typeof str === 'string') {
        try {
            const obj = JSON.parse(str);
            if (typeof obj === 'object' && obj) {
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            return false;
        }
    }
    return false;
}
/**
 * @description 转传参数序列化为链接
 * @param {string} url
 * @param {Object} params
 */
export function joinParams(url, params) {
    if (!/\?/.test(url)) {
        url += '?';
    }
    const keyValues = Object.keys(params || {}).map((key) => {
        return `${key}=${params[key]}`;
    });
    return url + keyValues.join('&');
}
/**
 * @description 从秒转成分、钟时间
 * @param {number} ms
 */
export function msToTime(ms) {
    if (ms <= 60)
        return '1分钟';
    else if (ms <= 60 * 60)
        return Math.ceil(ms / 60) + '分钟';
    else if (ms <= 60 * 60 * 24)
        return Math.ceil(ms / 3600) + '小时';
    else
        return Math.ceil(ms / (60 * 60 * 24)) + '天';
}
/**
 * @description 判断时间戳是否是今天
 * @param {any} someDate
 */
export function isToday(someDate) {
    someDate = new Date(someDate);
    const today = new Date();
    return (someDate.getDate() === today.getDate() &&
        someDate.getMonth() === today.getMonth() &&
        someDate.getFullYear() === today.getFullYear());
}
/**
 * @description 使用async-await方式，拒绝循环的try-catch
 * @param {Promise<any>} handler
 */
export function promiseHandler(handler) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return [yield handler, null];
        }
        catch (error) {
            return [null, error];
        }
    });
}
/**
 * @description 判断移动平台（微信、QQ、微博、QQ空间、UC浏览器）
 */
export function platform(ua = window.navigator.userAgent) {
    let platform;
    if (/MicroMessenger/.test(ua)) {
        platform = 'wx';
    }
    else if (/QQ\//.test(ua)) {
        platform = 'qq';
    }
    else if (/\bWeibo|__weibo__\d/.test(ua)) {
        platform = 'weibo';
    }
    else if (/Qzone\//.test(ua)) {
        platform = 'qzone';
    }
    else if (/UCBrowser/.test(ua)) {
        platform = 'uc';
    }
    else {
        platform = 'other';
    }
    return platform;
}
/**
 *@param 创建下载文件
 * @param {any} blob  ：返回数据的blob对象或链接
 * @param {string} fileName  ：下载后的命名 xx.docx 等
 */
export function downloadFile(blob, fileName) {
    let downloadElement = document.createElement('a');
    let href = blob;
    if (typeof blob == 'string') {
        downloadElement.target = '_blank';
    }
    else {
        href = window.URL.createObjectURL(blob);
    }
    downloadElement.href = href;
    downloadElement.download = fileName;
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    if (typeof blob != 'string') {
        window.URL.revokeObjectURL(href);
    }
}
/**
 * @description 通过 A 标签打开链接
 * @param {string} uri - 需要打开的地址
 */
export function evokeByTagA(uri, isClean = true, target = '_self') {
    const tagA = document.createElement('a');
    tagA.setAttribute('href', uri);
    tagA.setAttribute('target', target); // 在未安装ios手雷时scheme会有问题
    tagA.style.display = 'none';
    // append 在 android 6 系统中有兼容性问题
    // eslint-disable-next-line unicorn/prefer-node-append
    document.body.appendChild(tagA);
    tagA.click();
    isClean && document.body.removeChild(tagA);
}
/**
 * @description 通过 iframe 标签打开链接
 * iframe 模式可以同时支持外部浏览器和迅雷11内部浏览器来调用thunderx协议
 * @param {string} src - 需要打开的地址
 */
export function evokeByIframe(src, timeout = 2000) {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    setTimeout(() => document.body.removeChild(iframe), timeout);
}
export function callIOS(data) {
    return __awaiter(this, void 0, void 0, function* () {
        const { type = 'universalLink', target, action, params, from, timeout = 3000, callback, isClean = true, isJustUrl = false, } = data;
        const queryParams = Object.entries(params)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        let href = '';
        const path = `xunlei://${target}/${action}?${queryParams}`;
        if (type === 'scheme') {
            href = path;
        }
        else {
            href = 'oia-pan-ssl.xunlei.com';
            const query = encodeURIComponent(path);
            href = `https://${href}/?query=${query}`;
            if (from) {
                href += `&ct=${from}`;
            }
        }
        if (isJustUrl)
            return href;
        evokeByTagA(href, isClean);
        if (callback) {
            yield sleep(timeout);
            if (!document.hidden)
                callback();
        }
        return;
    });
}
/**
 * @description 在inline web worker中运行函数
 * @param {Function} func - 函数
 * @param {any[]} message - 函数参数
 * @returns {Promise} - 返回Promise对象执行结果
 */
export function promiseWorkerFun(func, ...message) {
    const delegate = () => {
        onmessage = ({ data: { func, message } }) => {
            const wrapper = (fn) => Function('"use strict"; return (' + fn.toString() + ')')();
            const result = wrapper(func)(...message);
            postMessage(result);
        };
    };
    const functionBody = delegate
        .toString()
        .replace(/^[^{]*{\s*/, '')
        .replace(/\s*}[^}]*$/, '');
    return new Promise((resolve, reject) => {
        const worker = new Worker(URL.createObjectURL(new Blob([functionBody], { type: 'text/javascript' })));
        worker.onmessage = ({ data }) => {
            resolve(data);
            worker.terminate();
        };
        worker.onerror = worker.onmessageerror = reject;
        worker.postMessage({ func: func.toString(), message });
        return worker;
    });
}
export function callAndroid(data) {
    return __awaiter(this, void 0, void 0, function* () {
        const { target, action, params, timeout = 3000, callback, isClean = true, isJustUrl = false, } = data;
        let queryParams = '';
        if (params) {
            queryParams = Object.entries(params)
                .map(([key, value]) => `${key}=${value}`)
                .join('&');
        }
        const scheme = 'xunleiapp://xunlei.com';
        let href = '';
        if (action) {
            href = `${scheme}/${target}/${action}?${queryParams}`;
        }
        else {
            href = `${scheme}/${target}?${queryParams}`;
        }
        if (isJustUrl)
            return href;
        evokeByTagA(href, isClean);
        if (callback) {
            yield sleep(timeout);
            if (!document.hidden)
                callback();
        }
        return;
    });
}
/**
 * @description 解析链接参数
*/
export function parseSearch(url = location.search) {
    const theRequest = new Object();
    if (url.indexOf("?") != -1) {
        const str = url.substring(1);
        const strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}
/**
 * @description head请求获取文件大小
 * @param {string} url - 请求的资源链接
*/
export function fetchSize(url) {
    return fetch(url, { method: 'HEAD' }).then(response => response.headers.get('Content-Length'));
}
/**
 * @description 请求文件用于下载,支持进度
 * @param {string} url - 请求资源链接
 * @param {object} options - 配置
 * @param {function} onprogress - 进度回调
*/
export function fetchFile(url, options = {}, onprogress) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield fetch(url, options);
        // @ts-ignore
        const reader = (_a = response.body) === null || _a === void 0 ? void 0 : _a.getReader();
        // @ts-ignore
        const contentLength = +response.headers.get('Content-Length');
        let receivedLength = 0;
        let chunks = [];
        let startTime = Date.now();
        let speed = 0;
        let loaded = 0;
        while (true) {
            // @ts-ignore
            const { done, value } = yield reader.read();
            if (done) {
                break;
            }
            chunks.push(value);
            // @ts-ignore
            receivedLength += value.length;
            speed = Math.round(receivedLength - loaded) / (Date.now() - startTime);
            startTime = Date.now();
            loaded = receivedLength;
            onprogress && onprogress(receivedLength, contentLength, Math.round(speed * 1000));
        }
        let chunksAll = new Uint8Array(receivedLength); // (4.1)
        let position = 0;
        for (let chunk of chunks) {
            // @ts-ignore
            chunksAll.set(chunk, position); // (4.2)
            // @ts-ignore
            position += chunk.length;
        }
        return new Blob(chunks);
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL3V0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOzs7OztHQUtHO0FBQ0gsTUFBTSxVQUFVLFNBQVMsQ0FBQyxFQUFZLEVBQUUsT0FBWTtJQUNsRCxPQUFPLFVBQVUsR0FBRyxJQUFTO1FBQzNCLE9BQU8sSUFBSSxPQUFPLENBQUMsQ0FBQyxPQUFPLEVBQUUsTUFBTSxFQUFFLEVBQUU7WUFDckMsTUFBTSxFQUFFLEdBQUcsQ0FBQyxHQUFRLEVBQUUsT0FBWSxFQUFFLEVBQUU7Z0JBQ3BDLElBQUksR0FBRyxFQUFFO29CQUNQLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQztpQkFDYjtxQkFBTTtvQkFDTCxPQUFPLENBQUMsT0FBTyxDQUFDLENBQUM7aUJBQ2xCO1lBQ0gsQ0FBQyxDQUFDO1lBQ0YsRUFBRSxDQUFDLEtBQUssQ0FBQyxPQUFPLEVBQUUsQ0FBQyxHQUFHLElBQUksRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDO1FBQ25DLENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQyxDQUFDO0FBQ0osQ0FBQztBQUVEOzs7OztHQUtHO0FBQ0gsTUFBTSxVQUFVLGNBQWMsQ0FBQyxHQUFXLEVBQUUsSUFBWTtJQUN0RCxJQUFJLENBQUMsR0FBRyxJQUFJLENBQUMsSUFBSTtRQUFFLE9BQU87SUFDMUIsT0FBTyxHQUFHLENBQUMsS0FBSyxDQUFDLElBQUksTUFBTSxDQUFDLEtBQUssSUFBSSxTQUFTLElBQUksWUFBWSxDQUFDLENBQUM7UUFDOUQsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxFQUFFO1FBQ1gsQ0FBQyxDQUFDLEVBQUUsQ0FBQztBQUNULENBQUM7QUFFRDs7OztHQUlHO0FBQ0gsTUFBTSxVQUFVLFdBQVcsQ0FBQyxLQUFhLEVBQUUsS0FBSyxHQUFHLENBQUM7SUFDbEQsSUFBSSxNQUFNLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFO1FBQ3RCLE9BQU8sS0FBSyxDQUFDO0tBQ2Q7SUFDRCxNQUFNLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQyxVQUFVO0lBQzFCLE1BQU0sS0FBSyxHQUFHLENBQUMsR0FBRyxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQztJQUNwRSxNQUFNLENBQUMsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBQ3BELE1BQU0sR0FBRyxHQUFHLEtBQUssR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQztJQUNuQyxJQUFJLElBQUksR0FBRyxHQUFHLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDO0lBQzlCLElBQUksR0FBRyxHQUFHLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQzFCLE9BQU8sSUFBSSxHQUFHLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUN6QixDQUFDO0FBRUQ7OztHQUdHO0FBQ0gsTUFBTSxVQUFVLFVBQVUsQ0FBQyxJQUEyQjtJQUNwRCxJQUFJLEdBQUcsUUFBUSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ3RCLElBQUksQ0FBQyxJQUFJLEVBQUU7UUFDVCxPQUFPLENBQUMsQ0FBQztLQUNWO0lBQ0QsTUFBTSxPQUFPLEdBQUcsQ0FBQyxHQUFHLEVBQUUsSUFBSSxFQUFFLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxDQUFDLENBQUM7SUFDM0MsSUFBSSxLQUFLLEdBQUcsQ0FBQyxDQUFDO0lBQ2QsT0FBTyxJQUFJLEdBQUcsSUFBSSxFQUFFO1FBQ2xCLElBQUksR0FBRyxJQUFJLEdBQUcsSUFBSSxDQUFDO1FBQ25CLEtBQUssRUFBRSxDQUFDO0tBQ1Q7SUFDRCxJQUFJLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztJQUMvQixJQUFJLE1BQU0sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDO1FBQUUsSUFBSSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDbEQsT0FBTyxHQUFHLElBQUksR0FBRyxPQUFPLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQztBQUNwQyxDQUFDO0FBRUQ7Ozs7R0FJRztBQUNILE1BQU0sVUFBVSxLQUFLLENBQUMsV0FBbUI7SUFDdkMsT0FBTyxJQUFJLE9BQU8sQ0FBQyxDQUFDLE9BQU8sRUFBRSxFQUFFO1FBQzdCLFVBQVUsQ0FBQyxHQUFHLEVBQUU7WUFDZCxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDaEIsQ0FBQyxFQUFFLFdBQVcsQ0FBQyxDQUFDO0lBQ2xCLENBQUMsQ0FBQyxDQUFDO0FBQ0wsQ0FBQztBQUNEOzs7R0FHRztBQUNILE1BQU0sVUFBVSxjQUFjLENBQUMsR0FBVztJQUN4QyxPQUFPLHVDQUF1QyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztBQUMzRCxDQUFDO0FBRUQ7OztHQUdHO0FBQ0gsTUFBTSxVQUFVLFdBQVcsQ0FBQyxHQUFXO0lBQ3JDLElBQUksT0FBTyxHQUFHLEtBQUssUUFBUSxFQUFFO1FBQzNCLElBQUk7WUFDRixNQUFNLEdBQUcsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1lBQzVCLElBQUksT0FBTyxHQUFHLEtBQUssUUFBUSxJQUFJLEdBQUcsRUFBRTtnQkFDbEMsT0FBTyxJQUFJLENBQUM7YUFDYjtpQkFBTTtnQkFDTCxPQUFPLEtBQUssQ0FBQzthQUNkO1NBQ0Y7UUFBQyxPQUFPLENBQUMsRUFBRTtZQUNWLE9BQU8sS0FBSyxDQUFDO1NBQ2Q7S0FDRjtJQUNELE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQztBQUVEOzs7O0dBSUc7QUFDSCxNQUFNLFVBQVUsVUFBVSxDQUN4QixHQUFXLEVBQ1gsTUFFQztJQUVELElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFO1FBQ25CLEdBQUcsSUFBSSxHQUFHLENBQUM7S0FDWjtJQUNELE1BQU0sU0FBUyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxJQUFJLEVBQUUsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDLEdBQUcsRUFBRSxFQUFFO1FBQ3RELE9BQU8sR0FBRyxHQUFHLElBQUksTUFBTSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUM7SUFDakMsQ0FBQyxDQUFDLENBQUM7SUFDSCxPQUFPLEdBQUcsR0FBRyxTQUFTLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0FBQ25DLENBQUM7QUFFRDs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsUUFBUSxDQUFDLEVBQVU7SUFDakMsSUFBSSxFQUFFLElBQUksRUFBRTtRQUFFLE9BQU8sS0FBSyxDQUFDO1NBQ3RCLElBQUksRUFBRSxJQUFJLEVBQUUsR0FBRyxFQUFFO1FBQUUsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFDLEVBQUUsR0FBRyxFQUFFLENBQUMsR0FBRyxJQUFJLENBQUM7U0FDcEQsSUFBSSxFQUFFLElBQUksRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFO1FBQUUsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFDLEVBQUUsR0FBRyxJQUFJLENBQUMsR0FBRyxJQUFJLENBQUM7O1FBQzNELE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFLEdBQUcsQ0FBQyxFQUFFLEdBQUcsRUFBRSxHQUFHLEVBQUUsQ0FBQyxDQUFDLEdBQUcsR0FBRyxDQUFDO0FBQ25ELENBQUM7QUFFRDs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsT0FBTyxDQUFDLFFBQWE7SUFDbkMsUUFBUSxHQUFHLElBQUksSUFBSSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQzlCLE1BQU0sS0FBSyxHQUFHLElBQUksSUFBSSxFQUFFLENBQUM7SUFDekIsT0FBTyxDQUNMLFFBQVEsQ0FBQyxPQUFPLEVBQUUsS0FBSyxLQUFLLENBQUMsT0FBTyxFQUFFO1FBQ3RDLFFBQVEsQ0FBQyxRQUFRLEVBQUUsS0FBSyxLQUFLLENBQUMsUUFBUSxFQUFFO1FBQ3hDLFFBQVEsQ0FBQyxXQUFXLEVBQUUsS0FBSyxLQUFLLENBQUMsV0FBVyxFQUFFLENBQy9DLENBQUM7QUFDSixDQUFDO0FBRUQ7OztHQUdHO0FBQ0gsTUFBTSxVQUFnQixjQUFjLENBQ2xDLE9BQW1COztRQUVuQixJQUFJO1lBQ0YsT0FBTyxDQUFDLE1BQU0sT0FBTyxFQUFFLElBQUksQ0FBQyxDQUFDO1NBQzlCO1FBQUMsT0FBTyxLQUFLLEVBQUU7WUFDZCxPQUFPLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO1NBQ3RCO0lBQ0gsQ0FBQztDQUFBO0FBRUQ7O0dBRUc7QUFDSCxNQUFNLFVBQVUsUUFBUSxDQUFDLEVBQUUsR0FBRyxNQUFNLENBQUMsU0FBUyxDQUFDLFNBQVM7SUFDdEQsSUFBSSxRQUFRLENBQUM7SUFDYixJQUFJLGdCQUFnQixDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsRUFBRTtRQUM3QixRQUFRLEdBQUcsSUFBSSxDQUFDO0tBQ2pCO1NBQU0sSUFBSSxNQUFNLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxFQUFFO1FBQzFCLFFBQVEsR0FBRyxJQUFJLENBQUM7S0FDakI7U0FBTSxJQUFJLHFCQUFxQixDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsRUFBRTtRQUN6QyxRQUFRLEdBQUcsT0FBTyxDQUFDO0tBQ3BCO1NBQU0sSUFBSSxTQUFTLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxFQUFFO1FBQzdCLFFBQVEsR0FBRyxPQUFPLENBQUM7S0FDcEI7U0FBTSxJQUFJLFdBQVcsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLEVBQUU7UUFDL0IsUUFBUSxHQUFHLElBQUksQ0FBQztLQUNqQjtTQUFNO1FBQ0wsUUFBUSxHQUFHLE9BQU8sQ0FBQztLQUNwQjtJQUNELE9BQU8sUUFBUSxDQUFDO0FBQ2xCLENBQUM7QUFFRDs7OztHQUlHO0FBQ0gsTUFBTSxVQUFVLFlBQVksQ0FBQyxJQUFTLEVBQUUsUUFBZ0I7SUFDdEQsSUFBSSxlQUFlLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUNsRCxJQUFJLElBQUksR0FBRyxJQUFJLENBQUM7SUFDaEIsSUFBSSxPQUFPLElBQUksSUFBSSxRQUFRLEVBQUU7UUFDM0IsZUFBZSxDQUFDLE1BQU0sR0FBRyxRQUFRLENBQUM7S0FDbkM7U0FBTTtRQUNMLElBQUksR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLGVBQWUsQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUN6QztJQUNELGVBQWUsQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDO0lBQzVCLGVBQWUsQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDO0lBQ3BDLFFBQVEsQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLGVBQWUsQ0FBQyxDQUFDO0lBQzNDLGVBQWUsQ0FBQyxLQUFLLEVBQUUsQ0FBQztJQUN4QixRQUFRLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxlQUFlLENBQUMsQ0FBQztJQUMzQyxJQUFJLE9BQU8sSUFBSSxJQUFJLFFBQVEsRUFBRTtRQUMzQixNQUFNLENBQUMsR0FBRyxDQUFDLGVBQWUsQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUNsQztBQUNILENBQUM7QUFFRDs7O0dBR0c7QUFDSCxNQUFNLFVBQVUsV0FBVyxDQUFDLEdBQVcsRUFBRSxPQUFPLEdBQUcsSUFBSSxFQUFFLE1BQU0sR0FBRyxPQUFPO0lBQ3ZFLE1BQU0sSUFBSSxHQUFHLFFBQVEsQ0FBQyxhQUFhLENBQUMsR0FBRyxDQUFDLENBQUM7SUFFekMsSUFBSSxDQUFDLFlBQVksQ0FBQyxNQUFNLEVBQUUsR0FBRyxDQUFDLENBQUM7SUFDL0IsSUFBSSxDQUFDLFlBQVksQ0FBQyxRQUFRLEVBQUUsTUFBTSxDQUFDLENBQUMsQ0FBQyx1QkFBdUI7SUFDNUQsSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLEdBQUcsTUFBTSxDQUFDO0lBQzVCLCtCQUErQjtJQUMvQixzREFBc0Q7SUFDdEQsUUFBUSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUM7SUFFaEMsSUFBSSxDQUFDLEtBQUssRUFBRSxDQUFDO0lBQ2IsT0FBTyxJQUFJLFFBQVEsQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQyxDQUFBO0FBQzVDLENBQUM7QUFFRDs7OztHQUlHO0FBQ0gsTUFBTSxVQUFVLGFBQWEsQ0FBRSxHQUFXLEVBQUUsT0FBTyxHQUFHLElBQUk7SUFDeEQsTUFBTSxNQUFNLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsQ0FBQTtJQUMvQyxNQUFNLENBQUMsWUFBWSxDQUFDLEtBQUssRUFBRSxHQUFHLENBQUMsQ0FBQTtJQUMvQixNQUFNLENBQUMsS0FBSyxDQUFDLE9BQU8sR0FBRyxNQUFNLENBQUE7SUFDN0IsUUFBUSxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsTUFBTSxDQUFDLENBQUE7SUFDakMsVUFBVSxDQUFDLEdBQUcsRUFBRSxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLE1BQU0sQ0FBQyxFQUFFLE9BQU8sQ0FBQyxDQUFBO0FBQzlELENBQUM7QUFnQkQsTUFBTSxVQUFnQixPQUFPLENBQUMsSUFBYzs7UUFDMUMsTUFBTSxFQUNKLElBQUksR0FBRyxlQUFlLEVBQ3RCLE1BQU0sRUFDTixNQUFNLEVBQ04sTUFBTSxFQUNOLElBQUksRUFDSixPQUFPLEdBQUcsSUFBSSxFQUNkLFFBQVEsRUFDUixPQUFPLEdBQUcsSUFBSSxFQUNkLFNBQVMsR0FBRyxLQUFLLEdBQ2xCLEdBQUcsSUFBSSxDQUFDO1FBQ1QsTUFBTSxXQUFXLEdBQUcsTUFBTSxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUM7YUFDdkMsR0FBRyxDQUFDLENBQUMsQ0FBQyxHQUFHLEVBQUUsS0FBSyxDQUFDLEVBQUUsRUFBRSxDQUFDLEdBQUcsR0FBRyxJQUFJLEtBQUssRUFBRSxDQUFDO2FBQ3hDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUNiLElBQUksSUFBSSxHQUFHLEVBQUUsQ0FBQztRQUNkLE1BQU0sSUFBSSxHQUFHLFlBQVksTUFBTSxJQUFJLE1BQU0sSUFBSSxXQUFXLEVBQUUsQ0FBQztRQUMzRCxJQUFJLElBQUksS0FBSyxRQUFRLEVBQUU7WUFDckIsSUFBSSxHQUFHLElBQUksQ0FBQztTQUNiO2FBQU07WUFDTCxJQUFJLEdBQUcsd0JBQXdCLENBQUM7WUFDaEMsTUFBTSxLQUFLLEdBQUcsa0JBQWtCLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDdkMsSUFBSSxHQUFHLFdBQVcsSUFBSSxXQUFXLEtBQUssRUFBRSxDQUFDO1lBQ3pDLElBQUksSUFBSSxFQUFFO2dCQUNSLElBQUksSUFBSSxPQUFPLElBQUksRUFBRSxDQUFDO2FBQ3ZCO1NBQ0Y7UUFDRCxJQUFJLFNBQVM7WUFBRSxPQUFPLElBQUksQ0FBQTtRQUMxQixXQUFXLENBQUMsSUFBSSxFQUFFLE9BQU8sQ0FBQyxDQUFDO1FBQzNCLElBQUksUUFBUSxFQUFFO1lBQ1osTUFBTSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUM7WUFDckIsSUFBSSxDQUFDLFFBQVEsQ0FBQyxNQUFNO2dCQUFFLFFBQVEsRUFBRSxDQUFDO1NBQ2xDO1FBQ0QsT0FBTTtJQUNSLENBQUM7Q0FBQTtBQUVEOzs7OztHQUtHO0FBQ0gsTUFBTSxVQUFVLGdCQUFnQixDQUFDLElBQWMsRUFBRSxHQUFHLE9BQWM7SUFDaEUsTUFBTSxRQUFRLEdBQUcsR0FBRyxFQUFFO1FBQ3BCLFNBQVMsR0FBRyxDQUFDLEVBQUUsSUFBSSxFQUFFLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxFQUFFLEVBQUUsRUFBRTtZQUMxQyxNQUFNLE9BQU8sR0FBRyxDQUFDLEVBQVksRUFBRSxFQUFFLENBQy9CLFFBQVEsQ0FBQyx3QkFBd0IsR0FBRyxFQUFFLENBQUMsUUFBUSxFQUFFLEdBQUcsR0FBRyxDQUFDLEVBQUUsQ0FBQztZQUM3RCxNQUFNLE1BQU0sR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsR0FBRyxPQUFPLENBQUMsQ0FBQztZQUN6QyxXQUFXLENBQUMsTUFBTSxDQUFDLENBQUM7UUFDdEIsQ0FBQyxDQUFDO0lBQ0osQ0FBQyxDQUFDO0lBQ0YsTUFBTSxZQUFZLEdBQUcsUUFBUTtTQUMxQixRQUFRLEVBQUU7U0FDVixPQUFPLENBQUMsWUFBWSxFQUFFLEVBQUUsQ0FBQztTQUN6QixPQUFPLENBQUMsWUFBWSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQzdCLE9BQU8sSUFBSSxPQUFPLENBQUMsQ0FBQyxPQUFPLEVBQUUsTUFBTSxFQUFFLEVBQUU7UUFDckMsTUFBTSxNQUFNLEdBQUcsSUFBSSxNQUFNLENBQ3ZCLEdBQUcsQ0FBQyxlQUFlLENBQUMsSUFBSSxJQUFJLENBQUMsQ0FBQyxZQUFZLENBQUMsRUFBRSxFQUFFLElBQUksRUFBRSxpQkFBaUIsRUFBRSxDQUFDLENBQUMsQ0FDM0UsQ0FBQztRQUNGLE1BQU0sQ0FBQyxTQUFTLEdBQUcsQ0FBQyxFQUFFLElBQUksRUFBRSxFQUFFLEVBQUU7WUFDOUIsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO1lBQ2QsTUFBTSxDQUFDLFNBQVMsRUFBRSxDQUFDO1FBQ3JCLENBQUMsQ0FBQztRQUNGLE1BQU0sQ0FBQyxPQUFPLEdBQUcsTUFBTSxDQUFDLGNBQWMsR0FBRyxNQUFNLENBQUM7UUFDaEQsTUFBTSxDQUFDLFdBQVcsQ0FBQyxFQUFFLElBQUksRUFBRSxJQUFJLENBQUMsUUFBUSxFQUFFLEVBQUUsT0FBTyxFQUFFLENBQUMsQ0FBQztRQUN2RCxPQUFPLE1BQU0sQ0FBQztJQUNoQixDQUFDLENBQUMsQ0FBQztBQUNMLENBQUM7QUFjRCxNQUFNLFVBQWdCLFdBQVcsQ0FBQyxJQUFrQjs7UUFDbEQsTUFBTSxFQUNKLE1BQU0sRUFDTixNQUFNLEVBQ04sTUFBTSxFQUNOLE9BQU8sR0FBRyxJQUFJLEVBQ2QsUUFBUSxFQUNSLE9BQU8sR0FBRyxJQUFJLEVBQ2QsU0FBUyxHQUFHLEtBQUssR0FDbEIsR0FBRyxJQUFJLENBQUM7UUFDVCxJQUFJLFdBQVcsR0FBRyxFQUFFLENBQUE7UUFDcEIsSUFBSSxNQUFNLEVBQUU7WUFDVixXQUFXLEdBQUcsTUFBTSxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUM7aUJBQ2pDLEdBQUcsQ0FBQyxDQUFDLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxFQUFFLEVBQUUsQ0FBQyxHQUFHLEdBQUcsSUFBSSxLQUFLLEVBQUUsQ0FBQztpQkFDeEMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1NBQ2Q7UUFDRCxNQUFNLE1BQU0sR0FBRyx3QkFBd0IsQ0FBQztRQUN4QyxJQUFJLElBQUksR0FBRyxFQUFFLENBQUM7UUFDZCxJQUFJLE1BQU0sRUFBRTtZQUNWLElBQUksR0FBRyxHQUFHLE1BQU0sSUFBSSxNQUFNLElBQUksTUFBTSxJQUFJLFdBQVcsRUFBRSxDQUFDO1NBQ3ZEO2FBQU07WUFDTCxJQUFJLEdBQUcsR0FBRyxNQUFNLElBQUksTUFBTSxJQUFJLFdBQVcsRUFBRSxDQUFDO1NBQzdDO1FBRUQsSUFBSSxTQUFTO1lBQUUsT0FBTyxJQUFJLENBQUE7UUFDMUIsV0FBVyxDQUFDLElBQUksRUFBRSxPQUFPLENBQUMsQ0FBQztRQUMzQixJQUFJLFFBQVEsRUFBRTtZQUNaLE1BQU0sS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1lBQ3JCLElBQUksQ0FBQyxRQUFRLENBQUMsTUFBTTtnQkFBRSxRQUFRLEVBQUUsQ0FBQztTQUNsQztRQUNELE9BQU07SUFDUixDQUFDO0NBQUE7QUFFRDs7RUFFRTtBQUNGLE1BQU0sVUFBVSxXQUFXLENBQUMsR0FBRyxHQUFHLFFBQVEsQ0FBQyxNQUFNO0lBQy9DLE1BQU0sVUFBVSxHQUFRLElBQUksTUFBTSxFQUFFLENBQUM7SUFDckMsSUFBSSxHQUFHLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO1FBQzFCLE1BQU0sR0FBRyxHQUFHLEdBQUcsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDN0IsTUFBTSxJQUFJLEdBQUcsR0FBRyxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUM1QixLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFBRTtZQUNwQyxVQUFVLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7U0FDckU7S0FDRjtJQUNELE9BQU8sVUFBVSxDQUFDO0FBQ3BCLENBQUM7QUFFRDs7O0VBR0U7QUFDRixNQUFNLFVBQVUsU0FBUyxDQUFFLEdBQVc7SUFDcEMsT0FBTyxLQUFLLENBQUMsR0FBRyxFQUFFLEVBQUUsTUFBTSxFQUFFLE1BQU0sRUFBRSxDQUFDLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxFQUFFLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsZ0JBQWdCLENBQUMsQ0FBQyxDQUFBO0FBQ2hHLENBQUM7QUFFRDs7Ozs7RUFLRTtBQUNGLE1BQU0sVUFBZ0IsU0FBUyxDQUFDLEdBQVEsRUFBRSxPQUFPLEdBQUcsRUFBRSxFQUFFLFVBQTJCOzs7UUFDakYsSUFBSSxRQUFRLEdBQUcsTUFBTSxLQUFLLENBQUMsR0FBRyxFQUFFLE9BQU8sQ0FBQyxDQUFDO1FBQ3pDLGFBQWE7UUFDYixNQUFNLE1BQU0sR0FBRyxNQUFBLFFBQVEsQ0FBQyxJQUFJLDBDQUFFLFNBQVMsRUFBRSxDQUFDO1FBQzFDLGFBQWE7UUFDYixNQUFNLGFBQWEsR0FBRyxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLGdCQUFnQixDQUFDLENBQUM7UUFDOUQsSUFBSSxjQUFjLEdBQUcsQ0FBQyxDQUFDO1FBQ3ZCLElBQUksTUFBTSxHQUFHLEVBQUUsQ0FBQztRQUNoQixJQUFJLFNBQVMsR0FBRyxJQUFJLENBQUMsR0FBRyxFQUFFLENBQUM7UUFDM0IsSUFBSSxLQUFLLEdBQUcsQ0FBQyxDQUFBO1FBQ2IsSUFBSSxNQUFNLEdBQUcsQ0FBQyxDQUFDO1FBQ2YsT0FBTSxJQUFJLEVBQUU7WUFDVixhQUFhO1lBQ2IsTUFBTSxFQUFDLElBQUksRUFBRSxLQUFLLEVBQUMsR0FBRyxNQUFNLE1BQU0sQ0FBQyxJQUFJLEVBQUUsQ0FBQztZQUMxQyxJQUFJLElBQUksRUFBRTtnQkFDUixNQUFNO2FBQ1A7WUFFRCxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO1lBQ3JCLGFBQWE7WUFDWCxjQUFjLElBQUksS0FBSyxDQUFDLE1BQU0sQ0FBQztZQUMvQixLQUFLLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxjQUFjLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLEdBQUcsU0FBUyxDQUFDLENBQUM7WUFDdkUsU0FBUyxHQUFHLElBQUksQ0FBQyxHQUFHLEVBQUUsQ0FBQztZQUN2QixNQUFNLEdBQUcsY0FBYyxDQUFBO1lBQ3ZCLFVBQVUsSUFBSSxVQUFVLENBQUMsY0FBYyxFQUFFLGFBQWEsRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLEtBQUssR0FBRyxJQUFJLENBQUMsQ0FBQyxDQUFBO1NBQ2xGO1FBRUQsSUFBSSxTQUFTLEdBQUcsSUFBSSxVQUFVLENBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQyxRQUFRO1FBQ3hELElBQUksUUFBUSxHQUFHLENBQUMsQ0FBQztRQUNqQixLQUFJLElBQUksS0FBSyxJQUFJLE1BQU0sRUFBRTtZQUN2QixhQUFhO1lBQ2IsU0FBUyxDQUFDLEdBQUcsQ0FBQyxLQUFLLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQyxRQUFRO1lBQ3hDLGFBQWE7WUFDYixRQUFRLElBQUksS0FBSyxDQUFDLE1BQU0sQ0FBQztTQUMxQjtRQUNELE9BQU8sSUFBSSxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUE7O0NBQ3hCIn0=